// extracted by mini-css-extract-plugin
export var colorSquare = "_lk-0";
export var danger = "_lk-5";
export var lightPink = "_lk-8";
export var neutralBlue = "_lk-7";
export var neutralYellow = "_lk-6";
export var normal = "_lk-1";
export var primary = "_lk-2";
export var primaryLight = "_lk-3";
export var solidBlack = "_lk-g";
export var solidGreen = "_lk-b";
export var solidLightBlue = "_lk-d";
export var solidNavy = "_lk-c";
export var solidOrange = "_lk-f";
export var solidPink = "_lk-e";
export var solidRed = "_lk-9";
export var solidYellow = "_lk-a";
export var success = "_lk-4";